import React, { useState, useEffect } from 'react';
import TimeZoneConverter from '../shared/timezone';
import { TextHighlighter } from '../shared/textBold';
import { useSearchParams } from 'react-router-dom';
import 'react-tabs/style/react-tabs.css';
import swal from 'sweetalert';
import {
	createSearchParams,
	useNavigate,
	useOutletContext,
} from 'react-router-dom';
import HoverList from './hoverList';
import { useSwitchModel } from './hooks';
import { useGetLicenceStatus } from '../upload-docs/hooks';
import { useSelector } from 'react-redux';

export const ModelMatrixList = () => {
	const licence_check = useGetLicenceStatus()
	const switch_model_hook = useSwitchModel()
	const { paginatedData, vendor_id, category_id, searchData } = useOutletContext();
	const [isValidLicence, setisValidLicence] = useState(false)
	const PrivilagesList = useSelector(
		(state) => state?.privilageSlice?.allowedActions
	);



	useEffect(() => {
			if (licence_check.fetchStatus === 'idle') {
				if (licence_check.status === 'success') {
					if ("valid" === licence_check?.data?.message) {
						setisValidLicence(true)
					}
					else if (licence_check?.data?.status ===403){
						setisValidLicence(false)
					}
				   
				}
				else if (licence_check.status === 'error') {
					
				}
				
			}
	
		}, [licence_check.fetchStatus, licence_check.status, licence_check?.data])

	useEffect(() => {
	  if (switch_model_hook.isSuccess ){
		searchData()
	  }
	}, [switch_model_hook.isSuccess])

	function handleSwitch(model_name) {

		swal("Do you want to activate this model version", {
				buttons: ['Cancel', 'Continue'],
			}).then((value) => {
				if (value) {
					switch_model_hook.mutate({
												vendor_id: vendor_id,
												category_id: category_id,
												model_name: model_name
											})

					// Add your logout logic here
				} else {

				}
			})
		
	}
	


	return (
		<>
				
					{/* Table body head */}
					{paginatedData?.length > 0 && (
						<div className="flex gap-2 mb-2">
							<div className="grow px-5 py-1 text-xs flex items-center justify-between">
								<div className="flex-none w-[140px] pr-4">
									<label
										className={`font-black block w-[140px] relative cursor-pointer`}
									>
										Model Name
									</label>
								</div>
								<div className="flex-none pl-7 pr-4 text-center w-[140px]">
									<label className={`font-black block relative cursor-pointer`}>
										Training Status
									</label>
								</div>
								<div className="flex-none pl-7 pr-4 text-center w-[140px]">
									<label className={`font-black block relative cursor-pointer`}>
										Vendor
									</label>
								</div>
								<div className="flex-none pl-7 pr-4 text-center w-[140px]">
									<label className={`font-black block relative cursor-pointer`}>
										Category
									</label>
								</div>
								<div className="flex-none pl-7 pr-4 text-center w-[140px]">
									<label className={`font-black block relative cursor-pointer`}>
										Accuracy
									</label>
								</div>
								<div className="flex-none px-4 text-center w-[140px]">
									<label className={`font-black block relative cursor-pointer`}>
										Invoices trained on
									</label>
								</div>
								<div className="flex-none px-4 text-center w-[140px]">
									<label className={`font-black block relative cursor-pointer`}>
										Fields trained on
									</label>
								</div>
								<div className="flex-none px-4 text-center w-[140px]">
									<label className={`font-black block relative cursor-pointer`}>
										Pages Annotated
									</label>
								</div>
								<div className="flex-none pl-7 pr-4 text-center w-[140px]">
									<label className={`font-black block relative cursor-pointer`}>
										Trained by
									</label>
								</div>
								<div className="flex-none pl-7 pr-4 text-center w-[155px]">
									<label className={`font-black block relative cursor-pointer`}>
										Status
									</label>
								</div>
								<div className="flex-none pl-7 pr-4 text-center w-[155px]">
									<label className={`font-black block relative cursor-pointer`}>
										Model trained Date
									</label>
								</div>			
								<div className="flex-none pl-7 pr-4 text-center w-[155px]">
									<label className={`font-black block relative cursor-pointer pl-7`}>
										Run time
									</label>
								</div>								
							</div>
							{PrivilagesList.includes('trigger_build_model') && vendor_id && category_id && <div className="flex-none px-4 text-center w-[155px] !bg-gray-50">
									&nbsp;
							</div>}
						</div>
					)}
					{/* Table body Row */}
					{paginatedData?.length == 0 && (
						<div class="flex items-center justify-center h-12">
							<p class="text-gray-500 text-lg font-medium">No data found</p>
						</div>
					)}
					{paginatedData?.sort((a, b) => b?.active - a?.active)?.map((obj, index) => {
						return (
							<div key={`itm` + index} className={`${obj?.active ===true ? 'lBlue' : ''} flex gap-2 mb-2 tblLoop`}>
								<div className="grow border rounded-md px-5 py-8 text-sm flex items-center justify-between">
									<div className="w-[140px] relative flex border-r pr-4 items-center">
										<span
											title={obj?.model_name}
											className="absolute w-full block truncate"
										>
											{obj?.model_name ? (
												obj.model_name
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span
											title={obj?.final_status}
											className="absolute w-full block truncate"
										>
											{obj?.final_status ? (
												obj.final_status
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>

									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span
											title={obj?.vendor}
											className="absolute w-full block truncate"
										>
											{obj?.vendor ? (
												obj.vendor
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span
											title={obj?.category}
											className="absolute w-full block truncate"
										>
											{obj?.category ? (
												obj.category
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span
											title={obj?.accuracy}
											className="absolute w-full block truncate"
										>
											{obj?.accuracy ? (
												obj.accuracy
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span
											title={obj?.num_documents}
											className="absolute w-full block truncate"
										>
											{obj?.num_documents ? (
												obj.num_documents
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex relative w-[140px] hoverParent">
										<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] ">
											<span className="absolute w-full block truncate cursor-pointer">
												{obj?.num_fileds ? (
													obj.num_fileds
												) : (
													<span className="text-gray-500">-</span>
												)}
											</span>
										</div>

										{/* Show HoverList to the right on hover */}
										<div className="absolute top-0 left-[100px] hoverList group-hover:block z-10">
											<HoverList data={obj?.entities} />
										</div>
									</div>
									<div className="flex-none flex items-center border-r pr-4 text-center w-[140px] relative">
										<span className="absolute w-full block truncate"
											title={obj?.num_annotations}
										>
											{obj?.num_annotations ? (
												obj.num_annotations
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>

									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.trained_by}
											className="absolute w-full block truncate"
										>
											{obj?.trained_by ? (
												obj.trained_by
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.status}
											className="absolute w-full block truncate"
										>
											{obj?.status ? (
												obj.status
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.end_time}
											className="absolute w-full block truncate"
										>
											{obj?.end_time ? (
												<TimeZoneConverter utcTimestamp={obj.end_time} />
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>	
									
									<div className="flex-none flex items-center pr-4 text-center w-[155px] relative">
										<span
											title={obj?.run_time}
											className="absolute w-full block truncate"
										>
											{obj?.run_time ? (
												obj.run_time
											) : (
												<span className="text-gray-500">-</span>
											)}
										</span>
									</div>								
									
								</div>
								{PrivilagesList.includes('trigger_build_model') && vendor_id && category_id &&  <div className="flex-none flex pr-2  !bg-gray-50 w-[155px]">
										{'active' in obj && obj['active'] == true && <span
										>
											<span className="truncate w-[130px] h-[66px] vLBG block px-3 pt-6 text-center text-primary text-sm rounded-md font-black mx-1 text-gray-500">Active</span>
										</span> }
										{'active' in obj && obj['active'] == false && <button
											disabled={obj["model_in_progress"] ==true || !['completed', 'failed'].includes(obj?.final_status.toLocaleLowerCase()) || !isValidLicence || switch_model_hook.isPending || licence_check.isFetching}
											onClick={() => handleSwitch(obj.model_name) }
											type="button"
											className="w-[130px] vLBG block px-0 py-3 text-center text-primary text-sm rounded-md font-black mx-1 opacity-60 disabled:bg-gray-200 disabled:text-gray-500"
										>
											Set as Current
										</button> }

										
									
									</div>}
							</div>
						);
					})}
			</>
	);
};
